import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const scrollPositions = {};

export default function ScrollRestoration() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    // Save scroll position for previous page
    scrollPositions[prevPath.current] = window.scrollY;

    // If navigation is POP (back/forward), restore scroll
    // Otherwise, scroll to top
    const savedY = scrollPositions[location.pathname];
    if (
      window.history.state &&
      window.history.state.idx < window.history.length - 1 &&
      savedY !== undefined
    ) {
      window.scrollTo({ top: savedY, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    prevPath.current = location.pathname;
    // eslint-disable-next-line
  }, [location.pathname]);

  return null;
} 